import { ReactElement } from "react"
import { useTranslation } from "../TranslationProvider"
import styled from "@emotion/styled"

export default function Spotify(): ReactElement {
  const { t } = useTranslation()

  return (
    <SpotifyWrapper>
      <SpotifyContainer>
        <iframe
          title={t("media.repertoireTitle")}
          src="https://open.spotify.com/embed/playlist/0FDSKPimQw13i0iuNmOOWL?utm_source=generator"
          width="100%"
          height="600"
          style={{ border: "none" }}
          allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
          loading="eager"
        />
      </SpotifyContainer>
    </SpotifyWrapper>
  )
}

const SpotifyWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 2rem;
  user-select: none;
`

const SpotifyContainer = styled.div`
  min-width: min(50vw, 60rem);
  max-width: 60rem;

  iframe {
    width: 100%;
    border-radius: 0.5rem;
  }
`
